import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {SizeModel} from '../../../../models/SizeModel';
import {SizeAnagrafService} from '../../../general-services/service-size-anagraf/size-anagraf.service';

@Component({
  selector: 'app-edit-size-anagraf',
  templateUrl: './edit-size-anagraf.component.html',
  styleUrls: ['./edit-size-anagraf.component.scss']
})
export class EditSizeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  size: SizeModel;
  registerForm: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  sizeCod: string;
  description: string;
  sizeJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private sizeService: SizeAnagrafService, private _activatedRoute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.sizeJson = params['row'];
      });

    this.size = new SizeModel();

    this.formBuilder = new FormBuilder();

    this.registerForm = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.size = JSON.parse(this.sizeJson) as SizeModel;

    this.registerForm.patchValue({
      cod: this.size ? this.size.cod : ''
    });

    this.registerForm.patchValue({
      description: this.size ? this.size.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.sizeCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SIZE_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.size.cod = this.registerForm.controls['cod'].value;
      this.size.description = this.registerForm.controls['description'].value;
      this.saveSubscribe = this.sizeService.update(this.sizeService.baseUrl, this.size).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Size Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Size with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SIZE_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
